import { getConfig } from '@sortlist-frontend/config';
import { ImageSourceHelper } from '@sortlist-frontend/media';

const { publicEnv } = getConfig();
const { s3Bucket: s3BucketUrl } = publicEnv;

const yale = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/yale.svg`);
const linkedin = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/linkedin.svg`);
const audi = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/audi.svg`);
const blizzard = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/blizzard.svg`);
const bbc = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/bbc.svg`);
const amazon = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/amazon.svg`);
const adobe = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/adobe.svg`);
const farm = ImageSourceHelper.fromUrl(`${s3BucketUrl}/logos/companies/farm.svg`);

export const AVAILABLE_COMPANIES = {
  yale: { src: yale, width: 50, height: 20 },
  linkedin: { src: linkedin, width: 50, height: 20 },
  audi: { src: audi, width: 50, height: 25 },
  blizzard: { src: blizzard, width: 50, height: 25 },
  bbc: { src: bbc, width: 50, height: 15 },
  amazon: { src: amazon, width: 50, height: 15 },
  adobe: { src: adobe, width: 50, height: 12 },
  farm: { src: farm, width: 50, height: 16 },
};
